<!--
 * @Author: hongye
 * @Date: 2020-09-17 18:54:44
 * @LastEditTime: 2020-09-23 14:12:56
 * @Description: 
-->
<template>
 <div class="apiDocIndex">
     <p class="api_doc_h3">
         <i class="iconfont iconapiwendang_jianjie"></i><span>API简介</span>
     </p>
     <p class="api_doc_text">为了更好的服务广大客户，极兔开放平台提供标准统一的接入API，为客户与平台直接实现数据的交互，提高双方的便利。本平台将接入的流程和步骤进行详细的描述，方便客户更快速准确的接入API平台。</p>
     <p class="api_doc_h3">
         <i class="iconfont iconapiwendang_duijieliucheng"></i><span>对接流程</span>
     </p>
     <div class="api_doc_text_w">
         <p class="api_doc_text">1.注册用户，注册成为极兔开放平台的一员</p>
         <p class="api_doc_text">2.申请成为开发者，完善开发者信息，成为极兔开放平台普通开发者。</p>
         <p class="api_doc_text">3.企业认证，完善企业信息，获取全部接口权限，可使用订单服务、电子面单服务等。</p>
         <p class="api_doc_text">4.联调测试，调试测试环境接口服务，与具体的接口服务人员沟通解决问题。</p>
         <p class="api_doc_text">5.发布上线，联调测试通过后，联系具体的接口服务人员，确认上线细节。</p>
     </div>
      <p class="api_doc_h3">
         <i class="iconfont iconapiwendang_qianmingfangshi"></i><span>签名方式</span>
     </p>
 <div class="api_doc_text_w">
         <p class="api_doc_text">1. 使用http协议表单提交的方式进行信息交互，字符编码默认统一采用UTF-8，数据格式：application/x-www-form-urlencoded;</p>
         <p class="api_doc_text">2. apiAccount和privateKey由平台提供； digest=base64(md5(业务参数的Json+privateKey))，注：先md5得到字节数组，再base64加密;</p>
         <p class="api_doc_text">3. 例如：base64(MD5({“age”:18,”gender”:”male”,”name”:”张三”}123456)) 如签名错误，可以对url进行编码然后发送请求。 </p>
         <p class="api_doc_text">4. 字段类型约定：需要严格依据字段表格中给出的参数格式和大小进行开发。</p>
         <p class="api_doc_text">5. 字段解析约定：参数字段中的必选字段是每次调用接口时都要求必须传入的；</p>
         <p class="api_doc_text">6. 部分接口示例代码和sdk请参考示例代码、SDK文档。</p>
     </div>


 </div>
</template>

<script>
 export default {
  name: 'apiDocIndex',
  data () {
   return {

   }
  },
  components: {

  }
 }
</script>

<style scoped lang="scss">
.apiDocIndex{
    box-sizing: border-box;
    padding: 20px 30px;
    .iconfont{
        font-size: 24px;
        color: $theme-color;
        margin-right: 14px;
    }
    .api_doc_h3{
        font-size: 22px;
        font-family: PingFang, PingFang-SC;
        font-weight: SC;
        text-align: left;
        color: #2b2d42;
        line-height: 42px;
        &:not(:nth-of-type(1)){
            margin-top: 30px;
        }
        span{
            font-weight: 600;
        }
    }
    .api_doc_text{
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #61666d;
        line-height: 22px;
        margin-top: 25px;
    }


}
 
</style>
